var heroHeight = jQuery('.hero-main').height();
jQuery('.hero .hero-img-container').css('height', heroHeight);
